import { EDeviceCategory } from '../conf/device-categories';
import { EDeviceModel } from '../conf/device-models';
import { IOPayload } from './io-payload';
import { NotifyAdvanceConfig } from './mail-notification-config';

export enum DeviceTechnicianRole {
    SUP_REQ_CLOSED = 0,
    TECH_OWNER = 1,
    SUP_REQ_OPENED = 2,
}

export class Device {
    Id?: number;
    Name = '';
    Description = '';
    IconName: string;
    ModelId: number;
    SiteId: number;
    OwnerId?: number;
    CurrentlyOwned?: boolean;
    Keycode?: string;
    ParentId?: number;
    RootId?: number;
    CategoryId?: number;
    CrpItemId?: number;
    Terminals?: IOPayload[];
    ConnectedAutomations?: ConnectedAutomations[];
}

export class ConnectedAutomations {
    Id: number;
    Name: string;
    ParentId?: number;
    CrpClassName?: string;
    CrpItemId?: number;
    UpdatedAt?: Date;
    CreatedAt?: Date;
}

export const supportCommands = (modelId: number, categoryId: number): boolean => [
    EDeviceModel.MultiIO,
    EDeviceModel.Output
].includes(modelId) || categoryId === EDeviceCategory.Automation;

export interface InstalledView {
    Id: number;
    Name: string;
    Description: string;
    ParentId: number;
    RootId: number;
    IconName: string;
    RemotesMax: number;
    ModelId: number;
    ModelName: string;
    ModelDescription: string;
    Keycode: string;
    RegistryId: number;
    SiteId: number;
    OwnerId: number;
    FirstName: string;
    LastName: string;
    CategoryId: number;
    Engagements: number;
    ManageDevice: boolean;
    MappedId: number;
    UpdatedAt: Date;
    CreatedAt: Date;
}

export interface NotificationView {
    Id: number;
    Name: string;
    Description: string;
    DefaultDescription: string;
    ParentId: number;
    RootId: number;
    IconName: string;
    RemotesMax: number;
    ModelId: number;
    ModelName?: string;
    ModelDescription?: string;
    Keycode: string;
    RegistryId: number;
    SiteId: number;
    SiteName: string;
    OwnerId: number;
    FirstName: string;
    LastName: string;
    CategoryId: number;
    Engagements: number;
    ManageDevice: boolean;
    MappedId?: number;
    UpdatedAt?: Date;
    CreatedAt?: Date;
    DeviceId?: number;
    AclRole: number;
    Notifications: NotifyAdvanceConfig[];
}

export interface DeviceInvitation {
    email: string;
    firstName: string;
    lastName: string;
    deviceId: number;
    remotesMax: number;
}

export const supportInfoNotif = (device: Device): boolean => device.CategoryId === EDeviceCategory.Virtual ||
    device.ModelId === EDeviceModel.RBE4 || device.ModelId === EDeviceModel.RBE4030 || device.ModelId === EDeviceModel.RBE4230 ||
    device.ModelId === EDeviceModel.GEN_RBE4;

export const supportWarnNotif = (device: Device): boolean => [
    EDeviceCategory.Automation,
    EDeviceCategory.Virtual
].includes(device.CategoryId) &&
    device.ModelId !== EDeviceModel.IORS485 && device.ModelId !== EDeviceModel.GEN_IORS485;

export const supportErrNotif = (device: Device): boolean => device.CategoryId === EDeviceCategory.Automation &&
    ![EDeviceModel.IORS485, EDeviceModel.GEN_IORS485,
    EDeviceModel.RBE4, EDeviceModel.RBE4030, EDeviceModel.RBE4230, EDeviceModel.GEN_RBE4,
    EDeviceModel.RBE230, EDeviceModel.RBE24, EDeviceModel.RBE24230, EDeviceModel.GEN_RBE24230].includes(device.ModelId);

export const supportManeuverNotif = (device: Device): boolean => device.CategoryId === EDeviceCategory.Automation &&
    ![EDeviceModel.IORS485, EDeviceModel.GEN_IORS485,
    EDeviceModel.RBE4, EDeviceModel.RBE4030, EDeviceModel.RBE4230, EDeviceModel.GEN_RBE4,
    EDeviceModel.RBE230, EDeviceModel.RBE24, EDeviceModel.RBE24230, EDeviceModel.GEN_RBE24230].includes(device.ModelId);

export const supportTasks = (device: Device): boolean => device.CategoryId === EDeviceCategory.Automation;
